export default "__VITE_ASSET__v1EQkO1f__"